export default "__VITE_ASSET__0bed9fa4__"